





























import { Component, Vue } from 'vue-property-decorator';
@Component({
     props: {
        header: String,
        ['options']: { type: Array, required: true },
    },
})
export default class Menu extends Vue {}
